/* tslint:disable */
/* eslint-disable */
/**
 * Products API
 * API for managing products
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NoticePeriodDurationDto } from './NoticePeriodDurationDto';
import {
    NoticePeriodDurationDtoFromJSON,
    NoticePeriodDurationDtoFromJSONTyped,
    NoticePeriodDurationDtoToJSON,
    NoticePeriodDurationDtoToJSONTyped,
} from './NoticePeriodDurationDto';
import type { TargetedSubscriberEnum } from './TargetedSubscriberEnum';
import {
    TargetedSubscriberEnumFromJSON,
    TargetedSubscriberEnumFromJSONTyped,
    TargetedSubscriberEnumToJSON,
    TargetedSubscriberEnumToJSONTyped,
} from './TargetedSubscriberEnum';

/**
 * 
 * @export
 * @interface UpdateProductCommand
 */
export interface UpdateProductCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateProductCommand
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductCommand
     */
    summary: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductCommand
     */
    fullDescription?: string;
    /**
     * New product logo. Absent keeps the current one; refused when the product has none.
     * @type {string}
     * @memberof UpdateProductCommand
     */
    storedFileId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductCommand
     */
    branchId: string;
    /**
     * Personne owning the product.
     * @type {string}
     * @memberof UpdateProductCommand
     */
    personId: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateProductCommand
     */
    isTacitRenewal: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateProductCommand
     */
    isFixedFormula?: boolean;
    /**
     * 
     * @type {TargetedSubscriberEnum}
     * @memberof UpdateProductCommand
     */
    targetedSubscriber?: TargetedSubscriberEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateProductCommand
     */
    plateformeIds: Array<string>;
    /**
     * 
     * @type {NoticePeriodDurationDto}
     * @memberof UpdateProductCommand
     */
    noticePeriodDuration: NoticePeriodDurationDto;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateProductCommand
     */
    isActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateProductCommand
     */
    isSepaActivated?: boolean;
}



/**
 * Check if a given object implements the UpdateProductCommand interface.
 */
export function instanceOfUpdateProductCommand(value: object): value is UpdateProductCommand {
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('summary' in value) || value['summary'] === undefined) return false;
    if (!('branchId' in value) || value['branchId'] === undefined) return false;
    if (!('personId' in value) || value['personId'] === undefined) return false;
    if (!('isTacitRenewal' in value) || value['isTacitRenewal'] === undefined) return false;
    if (!('plateformeIds' in value) || value['plateformeIds'] === undefined) return false;
    if (!('noticePeriodDuration' in value) || value['noticePeriodDuration'] === undefined) return false;
    return true;
}

export function UpdateProductCommandFromJSON(json: any): UpdateProductCommand {
    return UpdateProductCommandFromJSONTyped(json, false);
}

export function UpdateProductCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateProductCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'],
        'summary': json['summary'],
        'fullDescription': json['fullDescription'] == null ? undefined : json['fullDescription'],
        'storedFileId': json['storedFileId'] == null ? undefined : json['storedFileId'],
        'branchId': json['branchId'],
        'personId': json['personId'],
        'isTacitRenewal': json['isTacitRenewal'],
        'isFixedFormula': json['isFixedFormula'] == null ? undefined : json['isFixedFormula'],
        'targetedSubscriber': json['targetedSubscriber'] == null ? undefined : TargetedSubscriberEnumFromJSON(json['targetedSubscriber']),
        'plateformeIds': json['plateformeIds'],
        'noticePeriodDuration': NoticePeriodDurationDtoFromJSON(json['noticePeriodDuration']),
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'isSepaActivated': json['isSepaActivated'] == null ? undefined : json['isSepaActivated'],
    };
}

export function UpdateProductCommandToJSON(json: any): UpdateProductCommand {
    return UpdateProductCommandToJSONTyped(json, false);
}

export function UpdateProductCommandToJSONTyped(value?: UpdateProductCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'summary': value['summary'],
        'fullDescription': value['fullDescription'],
        'storedFileId': value['storedFileId'],
        'branchId': value['branchId'],
        'personId': value['personId'],
        'isTacitRenewal': value['isTacitRenewal'],
        'isFixedFormula': value['isFixedFormula'],
        'targetedSubscriber': TargetedSubscriberEnumToJSON(value['targetedSubscriber']),
        'plateformeIds': value['plateformeIds'],
        'noticePeriodDuration': NoticePeriodDurationDtoToJSON(value['noticePeriodDuration']),
        'isActive': value['isActive'],
        'isSepaActivated': value['isSepaActivated'],
    };
}

